export const ENDPOINTS = {
  AUTH: {
    GOOGLE_LOGIN: '/auth/google-login',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
  },
  TIME_ENTRIES: {
    LIST: (workspaceId: string) => `/workspaces/${workspaceId}/time-entries`,
    CREATE: (workspaceId: string) => `/workspaces/${workspaceId}/time-entries`,
    DETAIL: (workspaceId: string, id: string) => `/workspaces/${workspaceId}/time-entries/${id}`,
    UPDATE: (workspaceId: string, id: string) => `/workspaces/${workspaceId}/time-entries/${id}`,
    DELETE: (workspaceId: string, id: string) => `/workspaces/${workspaceId}/time-entries/${id}`,
    SUMMARY: (workspaceId: string) => `/workspaces/${workspaceId}/time-entries/summary`,
    START: (workspaceId: string) => `/workspaces/${workspaceId}/timer/start`,
    STOP: (workspaceId: string) => `/workspaces/${workspaceId}/timer/stop`,
    CURRENT: (workspaceId: string) => `/workspaces/${workspaceId}/timer`,
  },
  PROJECTS: {
    LIST: (workspaceId: string) => `/workspaces/${workspaceId}/projects`,
    LIST_WITH_TRACKED_HOURS: (workspaceId: string) =>
      `/workspaces/${workspaceId}/projects/with-tracked-hours`,
    ACCESSIBLE: (workspaceId: string) => `/workspaces/${workspaceId}/projects/accessible`,
    CREATE: (workspaceId: string) => `/workspaces/${workspaceId}/projects`,
    DETAIL: (workspaceId: string, id: string) => `/workspaces/${workspaceId}/projects/${id}`,
    UPDATE: (workspaceId: string, id: string) => `/workspaces/${workspaceId}/projects/${id}`,
    DELETE: (workspaceId: string, id: string) => `/workspaces/${workspaceId}/projects/${id}`,
  },
  CLIENTS: {
    LIST: (workspaceId: string) => `/workspaces/${workspaceId}/clients`,
    CREATE: (workspaceId: string) => `/workspaces/${workspaceId}/clients`,
    DETAIL: (workspaceId: string, id: string) => `/workspaces/${workspaceId}/clients/${id}`,
    UPDATE: (workspaceId: string, id: string) => `/workspaces/${workspaceId}/clients/${id}`,
    DELETE: (workspaceId: string, id: string) => `/workspaces/${workspaceId}/clients/${id}`,
  },
  REPORTS: {
    SUMMARY: (workspaceId: string) => `/workspaces/${workspaceId}/reports/summary`,
    DETAILED: (workspaceId: string) => `/workspaces/${workspaceId}/reports/detailed`,
    WEEKLY: (workspaceId: string) => `/workspaces/${workspaceId}/reports/weekly`,
    SMART_SUMMARY: (workspaceId: string) => `/workspaces/${workspaceId}/reports/smart/summary`,
    SMART_DETAILS: (workspaceId: string) => `/workspaces/${workspaceId}/reports/smart/details`,
  },
  DASHBOARD: {
    SUMMARY: (workspaceId: string) => `/workspaces/${workspaceId}/dashboard/summary`,
    TEAM_ACTIVITY: (workspaceId: string) => `/workspaces/${workspaceId}/dashboard/team-activity`,
  },
  TEAM: {
    LIST: (workspaceId: string) => `/workspaces/${workspaceId}/members`,
    INVITE: (workspaceId: string) => `/workspaces/${workspaceId}/members/invite`,
    UPDATE_ROLE: (workspaceId: string, userId: string) =>
      `/workspaces/${workspaceId}/members/${userId}/role`,
    DEACTIVATE: (workspaceId: string, userId: string) =>
      `/workspaces/${workspaceId}/members/${userId}/deactivate`,
    REACTIVATE: (workspaceId: string, userId: string) =>
      `/workspaces/${workspaceId}/members/${userId}/reactivate`,
    SET_BILLABLE_RATE: (workspaceId: string, userId: string) =>
      `/workspaces/${workspaceId}/members/${userId}/billable-rate`,
  },
  PROJECT_MEMBERS: {
    LIST: (workspaceId: string, projectId: string) =>
      `/workspaces/${workspaceId}/projects/${projectId}/members`,
    ADD: (workspaceId: string, projectId: string) =>
      `/workspaces/${workspaceId}/projects/${projectId}/members`,
    REMOVE: (workspaceId: string, projectId: string, userId: string) =>
      `/workspaces/${workspaceId}/projects/${projectId}/members/${userId}`,
  },
  WORKSPACE: {
    GET: '/workspace',
    UPDATE: '/workspace',
  },
  SETTINGS: {
    GET: '/settings',
    UPDATE: '/settings',
  },
  CONFIG: {
    GET: '/config',
  },
} as const;
